import router from '@/router/routes'
import { updateDeviceService } from '@/services/DeviceService'
import { updateFleetService } from '@/services/FleetService'
import { updateUserService } from '@/services/UserService'
import { updateVehicleService } from '@/services/VehicleService'
import { updateEnumService } from '@/services/EnumService'
import { updateEventService } from '@/services/EventService'
import { updateSnapshotService } from '@/services/SnapshotService'
import { updateRequestSnapshotService } from '@/services/RequestSnapshotService'
import { updateJourneyService } from '@/services/JourneyService'
import { updateRemotePlaybackService } from '@/services/RemotePlaybackService'
import { updateEventAlertLevelsSettingsService } from '@/services/EventAlertLevelsSettingsService'
import { updateEventAlertUserNotificationService } from '@/services/EventAlertUserNotificationService'
import { updateSettingService } from '@/services/SettingService'
import { updateReportService } from '@/services/ReportService'
import { updatesnapshotPackageService } from '@/services/SnapshotPackageService'
import { updateLiveNotificationService } from '@/services/LiveNotification'
import toast from '@/plugins/izitoast'
import { debounce } from 'lodash-es'

export default {
    autoLogout ({ dispatch, state }, expirationTime) {
        state.logoutTimeout = setTimeout(() => {
            dispatch('logout')
        }, expirationTime * 1000)
    },
    debouncedLogout: debounce(({ dispatch }, text) => {
        dispatch('logout')
    }, 100),
    logout ({ dispatch, commit, state }) {
        commit('clearAuth')
        // commit('signalRDisconnect')
        // localStorage.removeItem('accessToken')
        // localStorage.removeItem('tokenType')
        // localStorage.removeItem('expirationDate')
        // clearTimeout(state.logoutTimeout)
        dispatch('authModule/clearCredentials')
        dispatch('signalR/clearSignalRConnection')
        toast.error('Unauthorized')
        router.replace('/')
    },
    async autoLogin ({ commit, dispatch }) {
        const accessToken = localStorage.getItem('accessToken')
        const tokenType = localStorage.getItem('tokenType')

        if (!accessToken || !tokenType) {
            return
        }

        const now = new Date()
        const expirationDate = localStorage.getItem('expirationDate')
        if (now >= expirationDate) {
            return
        }

        commit('authUser', {
            access_token: accessToken,
            token_type: tokenType
        })
        // commit('signalRListen')
        dispatch('authorizeServices')
    },
    authorizeServices () {
        updateDeviceService(this.state.accessToken)
        updateFleetService(this.state.accessToken)
        updateUserService(this.state.accessToken)
        updateVehicleService(this.state.accessToken)
        updateEnumService(this.state.accessToken)
        updateEventService(this.state.accessToken)
        updateSnapshotService(this.state.accessToken)
        updateRequestSnapshotService(this.state.accessToken)
        updateJourneyService(this.state.accessToken)
        updateRemotePlaybackService(this.state.accessToken)
        updateEventAlertLevelsSettingsService(this.state.accessToken)
        updateEventAlertUserNotificationService(this.state.accessToken)
        updateSettingService(this.state.accessToken)
        updateReportService(this.state.accessToken)
        updatesnapshotPackageService(this.state.accessToken)
        updateLiveNotificationService(this.state.accessToken)
    },
    async login ({ commit, dispatch, state }, authData) {
        // wrapnac to do funkcji zeby nie musiec wszedzie pamietac jakie klucze trzeba czyscic
        localStorage.setItem('accessToken', authData.access_token)
        localStorage.setItem('tokenType', authData.token_type)
        localStorage.setItem('expirationTime', authData.expires_in)
        const now = new Date()
        const expirationDate = new Date(now.getTime() + authData.expires_in * 1000)
        localStorage.setItem('expirationDate', expirationDate)

        await commit('authUser', authData)
        await dispatch('autoLogout', authData.expires_in)
        await dispatch('authorizeServices')
        // await commit('signalRListen')
    }
}
